import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getCounts } from './info'
import utils from './utils'

const initStatus = () => {
	return {
		getOrders: {
			name: 'getOrders',

			isLoading: false,
			isSuccess: false,
			isError: false,
			message: '',
		},
		updateOrder: {
			name: 'updateOrder',
			isLoading: false,
			isSuccess: false,
			isError: false,
			message: '',
		},

		pastOrderDetails: {
			name: 'pastOrderDetails',
			isLoading: false,
			isSuccess: false,
			isError: false,
			message: '',
		},
	}
}
const status = utils.initStatus(['getOrders', 'updateOrder', 'pastOrderDetails'])

const initialState = {
	orders: [],
	status,
}
export const getOrders = createAsyncThunk('order/getOrders', async (params, thunkAPI) => {
	try {
		const { currBranch, token } = utils.getAuth(thunkAPI.getState())
		if (!token)
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.get(`/merchant/order/list/${currBranch}`, {
			headers: { Authorization: `Bearer ${token}` },
			...(params && { params }),
		})

		if (res.status == 200) {
			// thunkAPI.dispatch(getmerchantInfo())
			thunkAPI.dispatch(getCounts())
			return res.data
		}
		return thunkAPI.rejectWithValue(res)
	} catch (err) {
		return thunkAPI.rejectWithValue({
			...err.response,
			data: { message: 'Error while fetching orders' },
		})
	}
})

export const pastOrderDetails = createAsyncThunk(
	'order/pastOrderDetails',
	async (orderId, thunkAPI) => {
		try {
			const { currBranch, token } = utils.getAuth(thunkAPI.getState())
			if (!token)
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.get(`/merchant/order/details/${currBranch}`, {
				headers: { Authorization: `Bearer ${token}` },
				params: { orderId },
			})

			if (res.status == 200) {
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)

export const updateOrder = createAsyncThunk(
	'order/updateOrder',
	async ({ orderId, reason, status }, thunkAPI) => {
		try {
			const { currBranch, token } = utils.getAuth(thunkAPI.getState())
			if (!token)
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.post(
				`/merchant/order/update/${currBranch}`,
				{ reason, status },
				{
					headers: { Authorization: `Bearer ${token}` },
					params: { orderId },
				}
			)

			if (res.status == 200) {
				thunkAPI.dispatch(getOrders())
				return { ...res.data, message: 'Order placed successfully' }
			}

			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)

export const slice = createSlice({
	name: 'order',
	initialState,
	reducers: {
		clearState: (state, { payload }) => {
			utils.clearState(state, status, payload)
		},
	},
	extraReducers: {
		/*
    Get Orders
    */
		[getOrders.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			state.orders = data
			utils.handleSuccess(state.status.getOrders, { message: message, status: 200 })

			return state
		},
		[getOrders.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getOrders, payload?.data),
		[getOrders.pending]: state => utils.handleLoading(state.status.getOrders),
		/*
		Past Order Details
		*/

		[pastOrderDetails.fulfilled]: (state, { payload }) => {
			const { data, message } = payload

			state.currentOrder = data

			utils.handleSuccess(state.status.pastOrderDetails, { message: message, status: 200 })

			return state
		},
		[pastOrderDetails.rejected]: (state, { payload }) =>
			utils.handleError(state.status.pastOrderDetails, payload?.data),
		[pastOrderDetails.pending]: state => utils.handleLoading(state.status.pastOrderDetails),

		/*
    Place Order
    */
		[updateOrder.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			utils.handleSuccess(state.status.updateOrder, { message: message, status: 200 })
			return state
		},
		[updateOrder.rejected]: (state, { payload }) =>
			utils.handleError(state.status.updateOrder, payload?.data),
		[updateOrder.pending]: state =>
			utils.handleLoading(state.status.updateOrder, 'Updating order...'),
	},
})

export const { clearState } = slice.actions
// module.exports.clearStateFavorite =  slice.actions.clearState
export default slice.reducer
